Backbone = require 'backbone'

module.exports = DealsPaginationEvents = _.extend {}, Backbone.Events
